import { portalApi } from "@services/api/portalApi";
import { ReferralAssignee, ReferralAssignment, WellbeingReferral, WellbeingReferralAssignment } from "@godalming/api-types";

export async function getAllWellbeingAssignments() {
    try {
        const response = await portalApi.get<ReferralAssignment[]>('/referrals/wellbeing/all-assignments');
        return response.data;
    } catch (error) {
        console.error("Error fetching assignments:", error);
        throw error;
    }
}

export type CreateWellbeingReferral = {
    studentNumber: string;
    medicalIssue: boolean; mentalHealthIssue: boolean; sexualHealthIssue: boolean; academicIssue: boolean;
    careersIssue: boolean; learningSupportIssue: boolean; socialWorkerSupportIssue: boolean; otherIssue: boolean; counsellingIssue: boolean;
    otherDetails?: string; medicalDetails?: string; mentalHealthDetails?: string; sexualHealthDetails?: string;
    academicDetails?: string; careersDetails?: string; learningSupportDetails?: string; socialWorkerSupportDetails?: string;
    counsellingDetails?: string; counsellingOtherSupport?: string;
    counsellingLastThreeMonths?: string; counsellingGPSurgery?: string;
    selfConsciousnessLevel?: string; stressLevel?: string; anxietyLevel?: string; sadnessLevel?: string;
    irritabilityLevel?: string; lonelinessLevel?: string; concentrationDifficultyLevel?: string;
    selfCareDifficultyLevel?: string; relationshipTroubleLevel?: string; safetyConcernLevel?: string;
    needsContraceptiveAdvice: boolean; needsStiAdvice: boolean; needsPregnancySupport: boolean; sexualHealthOther: boolean;
};

export type AssignedCategory = 'me' | 'careers' | 'studentServices' | 'counselling' | 'learningSupport';
export type AssignedReferral = WellbeingReferralAssignment & {
    referralId: number; studentName: string; studentNumber: string; createdAt: string; createdByName: string; submittedOnBehalfOf: boolean;
};

export const createWellbeingReferral = async (request: CreateWellbeingReferral) =>
    (await portalApi.post<{ referralId: number }>('/referrals/wellbeing', request)).data;

export const deleteWellbeingReferral = async (referralId: number) =>
    portalApi.delete(`/referrals/wellbeing/${referralId}`);

export const getMyWellbeingReferrals = async () =>
    (await portalApi.get<WellbeingReferral[]>('/referrals/wellbeing/my')).data;

export const getAssignedWellbeingReferrals = async (category: AssignedCategory) =>
    (await portalApi.get<AssignedReferral[]>(`/referrals/wellbeing/assigned/${category}`)).data;

export type AwaitingActionWellbeingReferralCounts = {
    count: number;
    counts: Partial<Record<'Me' | 'Careers' | 'StudentServices' | 'Counselling' | 'LearningSupport', number>>;
};

export const getAwaitingActionWellbeingReferralCounts = async () =>
    (await portalApi.get<AwaitingActionWellbeingReferralCounts>('/referrals/wellbeing/assigned/awaiting-action-count')).data;

export const getUnassignedWellbeingReferralCount = async () =>
    (await portalApi.get<{ count: number }>('/referrals/wellbeing/unassigned-count')).data;

export const getAssignedWellbeingReferral = async (category: AssignedCategory, assignmentId: number) =>
    (await portalApi.get<WellbeingReferral & WellbeingReferralAssignment>(`/referrals/wellbeing/assigned/${category}/${assignmentId}`)).data;

export const actionAssignedWellbeingReferral = async (category: AssignedCategory, assignmentId: number, notes?: string) =>
    (await portalApi.post(`/referrals/wellbeing/assigned/${category}/${assignmentId}/action`, { notes })).data;

export const undoActionAssignedWellbeingReferral = async (category: AssignedCategory, assignmentId: number) =>
    (await portalApi.post(`/referrals/wellbeing/assigned/${category}/${assignmentId}/undo-action`)).data;

export const assignWellbeingReferral = async (request: NewReferralAssignmentRequest) =>
    (await portalApi.post('/referrals/wellbeing/assignments', request)).data;

export const remindWellbeingReferralAssignment = async (assignmentId: number) =>
    portalApi.post(`/referrals/wellbeing/assignments/${assignmentId}/remind`);

export type NewReferralAssignmentRequest = {
    referralId: number; assigneeUuid: string; notes?: string;
    medicalIssueVisible: boolean; mentalHealthIssueVisible: boolean; sexualHealthIssueVisible: boolean;
    academicIssueVisible: boolean; careersIssueVisible: boolean; learningSupportIssueVisible: boolean; socialWorkerSupportIssueVisible: boolean;
    otherIssueVisible: boolean; counsellingIssueVisible: boolean;
};

export async function getAllWellbeingReferrals() {
    try {
        const response = await portalApi.get<WellbeingReferral[]>('/referrals/wellbeing/all-referrals');
        return response.data;
    } catch (error) {
        console.error("Error fetching referrals:", error);
        throw error;
    }
}

export async function getAllWellbeingAssignees() {
    try {
        const response = await portalApi.get<ReferralAssignee[]>('/referrals/wellbeing/assignees');
        return response.data;
    } catch (error) {
        console.error("Error fetching assignees:", error);
        throw error;
    }
}

export async function getAssignmentsForReferral(referralId: number) {
    try {
        const response = await portalApi.get<WellbeingReferralAssignment[]>(`/referrals/wellbeing/assignments/${referralId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching assignments for referral ${referralId}:`, error);
        throw error;
    }
}
